import { httpClient, nError } from "../funcs"
import notifyUser, { notifyAboutError } from "./notifyUser"
import { RouteContext } from "react-router5/dist/types"
import { saveLegacyToken, saveCabinetOAuth2Session } from "./saveToken"
import { loadSelf } from "./loadSelf"
import { OAuth2Tokens } from "./oauth2Tokens"

// Интерфейс для токенов
interface TokenData {
    access_token: string
    refresh_token?: string
}

export async function finishAuth(
    props: any,
    $router: RouteContext,
    tokenData: TokenData,
    route: string | null = null,
    routeParams: Record<string, any> | null = null
) {
    try {
        // Определяем, это OAuth2 токены или старый формат
        const isOAuth2 = !!tokenData.refresh_token
        
        if (isOAuth2) {
            // OAuth2 токены - сохраняем как структуру
            const oauth2Tokens: OAuth2Tokens = {
                access_token: tokenData.access_token,
                refresh_token: tokenData.refresh_token!
            }
            
            await saveCabinetOAuth2Session(oauth2Tokens)
        } else {
            // Старый формат - сохраняем только access_token
            saveLegacyToken(tokenData.access_token)
        }
        
        // Fetch user info
        await loadSelf(props)

        // Show success notification
        notifyUser(props, 'Авторизация успешна')

        // Navigate to appropriate page
        let didNavigate = false
        const storedRedirect = props.$store.redirectUrl
        if (storedRedirect) {
            const { route: redirectRoute, params } = storedRedirect
            // Формат router: { route: string, params? }
            if (redirectRoute != null && typeof redirectRoute === 'string') {
                $router.router.navigate(redirectRoute, params ?? {})
                didNavigate = true
            } else if (storedRedirect.documentId != null) {
                // Формат со страницы Register ("Войти"): { documentType, documentId, additionalSigner? }
                const params: Record<string, any> = { contractId: storedRedirect.documentId }
                if (storedRedirect.additionalSigner != null && storedRedirect.additionalSigner >= 0) {
                    params.additional_signer = storedRedirect.additionalSigner
                }
                $router.router.navigate('contract', params)
                didNavigate = true
            }
            props.$commitToStore({
                redirectUrl: null
            })
        }
        if (!didNavigate && route) {
            setTimeout(() => {
                $router.router.navigate(route, routeParams ?? {})
            }, 0)
        } else if (!didNavigate && props.$store.inviteRoleId) {
            setTimeout(() => {
                $router.router.navigate('profile')
            }, 201)
        }
    }
    catch (error) {
        notifyAboutError(props, error)
    }
}